// extracted by mini-css-extract-plugin
module.exports = {"genre":"genres-module--genre--1j9Ym","score":"genres-module--score--unzFt"};